
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const LeadCoversionProbablity = () => {
  return (
    <SettingsMetaData propertyName={"Lead_CoversionProbablity"} viewPropertyName={"LeadCoversion Probablity"} />
  );
};
export default LeadCoversionProbablity;
